<template>
    <div v-if="popup">
        <div class="d-flex justify-content-between">
            <h5>Prezzo per unità</h5>
            <span>{{utils.euro(product.price)}}</span>
        </div>
        

        <div class="components">
            <div v-for="t in product.componentTypes" :key="t.id">
                <br>
                <b class="text-muted text-uppercase">{{t.name}}</b>
                <div v-for="c in product.availableComponents.filter(x => x.type.id === t.id)" class="component" :key="c.id">
                    <div>
                    <template v-if="t.type === 'single-choice'">
                        <input type="radio" :name="'component-'+t.id" :checked="selectedComponents.indexOf(c) !== -1" @change="setSingleChoice(c,t)">
                    </template>
                    <template v-if="t.type === 'multiple-choice'">
                        <input type="checkbox" v-model="selectedComponents" :value="c">
                    </template>
                    <span>&nbsp;{{c.name}}</span>
                    </div>
                    <span v-if="c.price">+{{utils.euro(c.price)}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="mv_product" v-else>
        <div>
            <b style="margin:0">{{product.name}}</b>
            <br>
            <small><i>{{defaultComponents}}</i></small>
            <small v-if="product.description" v-html="product.description"></small>
        </div>
        <div class="d-flex justify-content-center align-items-center mv_variants_container" v-if="product.availableVariants.length > 0">
            <div class="text-center ml-3 mv_variant" v-for="v in product.availableVariants" :key="v.id">
                <span>{{utils.euro(v.price)}}</span>
                <br>
                <small class="text-muted text-uppercase"><b>{{v.name}}</b></small>
            </div>
        </div>
        <span class="ml-3" v-else>{{utils.euro(product.price)}}</span>
        
    </div>
</template>

<script>
import utils from '@/utils'
export default {
    props: ["product", 'popup'],
    data(){
        return {
            utils,
            showComponents: false,
            selectedComponents: this.product.availableComponents.filter(x => x.default),
            quantity: 1
        }
    },
    methods: {
        setSingleChoice(c,t){
            this.selectedComponents = this.selectedComponents.filter(x => x.type.id !== t.id);
            this.selectedComponents.push(c);
        },
        addToCart(){
            let fields = {
                components: this.selectedComponents.map(m => m.id)
            }
            return fields;
        },
    },
    computed:{
        defaultComponents(){
            return this.product.availableComponents.filter(x => x.default).map(m => m.name).join(",");
        }
    }
}
</script>

<style lang="scss" scoped>

    .mv_product {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media screen and (max-width: 768px) {
            align-items: flex-start
        }
    }
    
     .component {
        padding: .5em;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        border-bottom: 1px solid #DDD;

        cursor: pointer;
        &.active {
            font-weight: 600;
        }
        &:last-of-type {
            border: none;
        }
    }


</style>